/**
 * contains the abi and contract address
*/

export default class ScriptsContract {
    constructor() {
        this.abi = [
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "scriptHash",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "scriptType",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "title",
				"type": "bytes32"
			}
		],
		"name": "newScript",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "scriptHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "scriptType",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "bytes32",
				"name": "title",
				"type": "bytes32"
			}
		],
		"name": "NewScript",
		"type": "event"
	}
        ];

        this.contractAddress = '0xA6FF112D42c50FEE6c212B775721185f82285844';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

